import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-multi-choice-confirm-dialog',
  templateUrl: './multi-choice-confirm-dialog.component.html',
  styleUrls: ['./multi-choice-confirm-dialog.component.scss'],
  standalone: false
})
export class MultiChoiceConfirmDialogComponent {
  @Input() title: string;
  @Input() textToDisplay: string;
  @Input() items: any;
  @Input() buttons: { text: string; color?: string; value: string }[];
  @Input() cancelText: string = 'Cancel';


  constructor(public dialogRef: MatDialogRef<MultiChoiceConfirmDialogComponent>) {
    this.dialogRef.addPanelClass('confirm-action-panel');
  }


  choose(value: string) {
    this.dialogRef.close(value);
  }
}
